// extracted by mini-css-extract-plugin
module.exports = {"root":"InsuranceDisclaimer_root__2Iab7"};